module.exports = __webpack_public_path__ + "static/img/4.414b205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/4.png
// module id = Dano
// module chunks = 13